module.exports = __webpack_public_path__ + "static/media/big_tire.835cd63e.svg";